export default function KeyTopics() {
  return (
    <section className="key-topics py-5">
      <div className="container">

        {/* Header */}
        <div className="text-center mb-5">
       
          <h2 className="mt-3 fw-bold display-6">Conference Theme/Key Topics</h2>
          <button className="btn btn-warning fw-semibold mt-3 rounded-pill px-4 py-2">
            Submit Speaking Proposal
          </button>
        </div>

        {/* Topics Grid */}
        <div className="row g-4">

          {/* 1 */}
          <div className="col-lg-4 col-md-6">
            <div className="topic-box p-4 rounded shadow-sm h-100">
              <div className="topic-icon mb-3 fs-3 text-pink">
                <i className="fa fa-microchip"></i>
              </div>
              <h5 className="fw-bold mb-2">AI-Powered Operations</h5>
              <p className="small m-0">
                Explore how AI transforms field operations, optimizes equipment performance, and minimizes downtime with real-time analytics and automated decision-making.
              </p>
            </div>
          </div>

          {/* 2 */}
          <div className="col-lg-4 col-md-6">
            <div className="topic-box p-4 rounded shadow-sm h-100">
              <div className="topic-icon mb-3 fs-3 text-pink">
                <i className="fa fa-cube"></i>
              </div>
              <h5 className="fw-bold mb-2">Digital Twins & Smart Assets</h5>
              <p className="small m-0">
                Discover how digital twin technology simulates and monitors assets, improves performance, reduces failures, and enables safer operations.
              </p>
            </div>
          </div>

          {/* 3 */}
          <div className="col-lg-4 col-md-6">
            <div className="topic-box p-4 rounded shadow-sm h-100">
              <div className="topic-icon mb-3 fs-3 text-pink">
                <i className="fa fa-database"></i>
              </div>
              <h5 className="fw-bold mb-2">Data-Driven Sustainability</h5>
              <p className="small m-0">
                Learn how data platforms and emissions tracking tools empower companies to meet ESG goals, cut carbon footprints, and align with regulations.
              </p>
            </div>
          </div>

          {/* 4 */}
          <div className="col-lg-4 col-md-6">
            <div className="topic-box p-4 rounded shadow-sm h-100">
              <div className="topic-icon mb-3 fs-3 text-pink">
                <i className="fa fa-shield"></i>
              </div>
              <h5 className="fw-bold mb-2">Cybersecurity in the Digital Oilfield</h5>
              <p className="small m-0">
                Address risk mitigation, compliance with new frameworks, and securing infrastructure in a connected environment as digital adoption rises.
              </p>
            </div>
          </div>

          {/* 5 */}
          <div className="col-lg-4 col-md-6">
            <div className="topic-box p-4 rounded shadow-sm h-100">
              <div className="topic-icon mb-3 fs-3 text-pink">
                <i className="fa fa-leaf"></i>
              </div>
              <h5 className="fw-bold mb-2">Green Hydrogen & CCUS</h5>
              <p className="small m-0">
                Explore investments and innovations in carbon capture and green hydrogen as decarbonization solutions for cleaner, scalable energy models.
              </p>
            </div>
          </div>

          {/* 6 */}
          <div className="col-lg-4 col-md-6">
            <div className="topic-box p-4 rounded shadow-sm h-100">
              <div className="topic-icon mb-3 fs-3 text-pink">
                <i className="fa fa-users"></i>
              </div>
              <h5 className="fw-bold mb-2">Workforce 5.0</h5>
              <p className="small m-0">
                Understand the shift toward digital roles, reskilling programs, and AI-enhanced safety technologies for efficient and inclusive operations.
              </p>
            </div>
          </div>

        </div>
      </div>

      {/* Custom CSS */}
      <style jsx>{`
        .topic-box {
          background: #fff;
          transition: all 0.3s ease;
        }
        .topic-box:hover {
          transform: translateY(-6px);
          box-shadow: 0px 8px 20px rgba(0,0,0,0.1);
        }
        .text-pink {
          color: #e63978 !important;
        }
      `}</style>
    </section>
  );
}
